import { render } from "./App.vue?vue&type=template&id=92698956"
const script = {}

import "./App.vue?vue&type=style&index=0&id=92698956&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__